jQuery(document).ready(function($) {
	console.log('ready2');
});

